import { render, staticRenderFns } from "./MemoryGame.component.vue?vue&type=template&id=4b3c35fe&scoped=true&"
import script from "./MemoryGame.component.vue?vue&type=script&lang=js&"
export * from "./MemoryGame.component.vue?vue&type=script&lang=js&"
import style0 from "./MemoryGame.component.vue?vue&type=style&index=0&id=4b3c35fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c35fe",
  null
  
)

export default component.exports